
class WidgetFundComparisonHelpers {

    getFundIdParameters(location, param) {
        const urlParams = new URLSearchParams(location);
        const initialFund = urlParams.get(param);
        if (initialFund) {
            return initialFund;
        }
        return false;
    }
    toTitleCase(str) {
        return str.toLowerCase().split('-').map(function (word) {
            return (word.charAt(0).toUpperCase() + word.slice(1));
        }).join(' ');
    }
    //Chart Functions 
    wordsToArray(words,maxTooltipLength) {
        let lines = [];
        let str = '';
        words.forEach(function (word) {
            if ((str.length + word.length + 1) <= maxTooltipLength) {
                str += word + ' ';
            } else {
                lines.push(str);
                str = word + ' ';
            }
        });
        lines.push(str);
        return lines;
    }

    //Return Chart Colors
    chartColors(){
        return [
            'rgb(255, 99, 132)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
        ];
    }

    processChartDataPoints(chartData,chartColors){
        let fundDataSet=[];
        for (let i = 0; i < chartData.length; i++) {
            fundDataSet.push({
                label: chartData[i].fundName,
                fundCurrency: chartData[i].fundCurr,
                backgroundColor: chartColors[i],
                borderColor: chartColors[i],
                data: chartData[i].fundData,
                type: 'line',
                pointStyle: 'circle',
                hitRadius: 6,
                pointRadius: 1,
                hoverRadius: 4,
                fill: false,
                borderWidth: 1
            });
        }
        return fundDataSet;
    }

    createChartLabel(tooltipItem, myData) {
        var chartArea = window.fundChart.chartArea;
        var label = myData.datasets[tooltipItem.datasetIndex].label || '';
        var currency = myData.datasets[tooltipItem.datasetIndex].fundCurrency || '';
        if (label) {
            label += ': ';
        }
        var roi = 0;
        var gainLoss = "";
        if (currency === "Peso") {
            roi = ((parseFloat(tooltipItem.value) - 10000.00) / 10000.00) * 100;
            gainLoss = roi > 0 ? `+${roi.toFixed(2)}%` : `${roi.toFixed(2)}%`;
            label += `PHP ${parseFloat(tooltipItem.value).toLocaleString()} (${gainLoss})`;
        } else {
            roi = (parseFloat(tooltipItem.value) - 1000.00) * 0.100;
            gainLoss = roi > 0 ? `+${roi.toFixed(2)}` : `${roi.toFixed(2)}`;
            label += `USD ${parseFloat(tooltipItem.value).toLocaleString()} (${gainLoss})`;
        }
        if (chartArea.right <= 480) {
            if (label.length <= 50) {
                return [label];
            }
            var words = label.split(':');
            return this.wordsToArray(words,50);
        } {
            return [label];
        }
    }

    chartConfiguration(fundDataSet){
        var cfg = {
            data: {
                datasets: fundDataSet
            },
            options: {
                maintainAspectRatio: false,
                cutoutPercentage: 60,
                layout: {
                    padding: {
                        right: 40
                    }
                },
                scales: {
                    xAxes: [{
                        type: 'time',
                        distribution: 'series',
                        offset: true,
                        time: {
                            unit: 'day',
                            displayFormats: {
                                'day': 'MMM DD',
                            }
                        },
                        ticks: {
                            major: {
                                enabled: true,
                                fontStyle: 'bold'
                            },
                            source: 'data',
                            autoSkip: true,
                            autoSkipPadding: 10,
                            maxRotation: 0,
                            sampleSize: 100
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            drawBorder: false
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Market Value'
                        }
                    }]
                },
                legend: {
                    position: 'bottom'
                },
                plugins: {
                    zoom: {
                        pan: {
                            enabled: true,
                            mode: 'x',
                        },
                        zoom: {
                            enabled: true,
                            mode: 'x', // or 'x' for "drag" version
                        }
                    }
                },
                tooltips: {
                    enabled: true,
                    mode: 'x',
                    bodyFontSize: 12,
                    padding: 20,
                    callbacks: {
                        label: (tooltipItem, myData) => {
                            return this.createChartLabel(tooltipItem, myData)[0];
                        },
                        afterLabel: (tooltipItem, myData) => {
                            return this.createChartLabel(tooltipItem, myData).splice(1);
                        }
                    }
                }
            }
        };

        return cfg;
    }

    processToolTipDataPoints(tooltip){
        if (tooltip.dataPoints) {
            var currentDataPoints = tooltip.dataPoints.filter(function (arr) {
                return arr.xLabel == tooltip.title[0];
            });
            //get indexof
            var currentbody = tooltip.body;
            var newBody = [];
            var newLabelColors = [];
            var newLabelTextColors = [];

            for (var i = 0; i < currentDataPoints.length; i++) {
                newBody.push(currentbody[tooltip.dataPoints.indexOf(currentDataPoints[i])]);
                newLabelColors.push(tooltip.labelColors[tooltip.dataPoints.indexOf(currentDataPoints[i])]);
                newLabelTextColors.push(tooltip.labelTextColors[tooltip.dataPoints.indexOf(currentDataPoints[i])]);
            }
            tooltip.dataPoints = currentDataPoints;
            tooltip.body = newBody;
            tooltip.labelColors = newLabelColors;
            tooltip.labelTextColors = newLabelTextColors;
            var chartArea = window.fundChart.chartArea;
            var labelHeight=0;
            if (chartArea.right <= 480) {
                labelHeight = currentDataPoints.length * 30;
            }else{
                labelHeight = currentDataPoints.length * 20;
            }
            tooltip.height = 22 + labelHeight;
        }
    }
    

    loadChart(chartData) {
        Chart.defaults.global.tooltips.custom = (tooltip) => {
            this.processToolTipDataPoints(tooltip);
            return;
        };

        var chartColors = this.chartColors();
        var ctx = document.getElementById('canvas').getContext('2d');
        
        var fundDataSet = this.processChartDataPoints(chartData,chartColors);        
        var cfg = this.chartConfiguration(fundDataSet);

        if (window.fundChart !== undefined) {
            window.fundChart.destroy();
        }
        window.fundChart = new Chart(ctx, cfg);
    }

    getAmtcProducts(url, amtcContentProductsPath) {
        return window.App.Api.GET(url, {
            params: {
                path: amtcContentProductsPath,
                provided_id: 1,
            }
        }).then(res => {
            return Promise.resolve(res);
        }).catch(error => {
            return Promise.reject(error);
        });
    }

    getAmtcProductsV2(path,processorEndpoint,contentHeaders){
        const getContentEndpoint =processorEndpoint;
        let origin = window.location.origin;
        let getContentHeaders="";
        try{
            getContentHeaders=JSON.parse(contentHeaders);
            getContentHeaders.path= origin + path;
        }catch(e){
            console.log("Please check headers");
        }
     
        let dataFromStorage=JSON.parse(sessionStorage.getItem("allfundcontent"));
        if(dataFromStorage){
            return Promise.resolve(dataFromStorage);
        }else{
            console.log("No cached data");
            return window.App.Api.GET(getContentEndpoint, {
                headers: getContentHeaders
            }).then(res => {
                sessionStorage.setItem("allfundcontent",JSON.stringify(res));
                return Promise.resolve(res);
            }).catch(error => {
                return Promise.reject(error);
            });
        }
    }
    
    apiRequestCanceller(){
        console.log("Cancelled!");
    }

    startSession(url,startheaders) {
        return window.App.Api.GET(url,{headers:startheaders}).then(res => {
            return Promise.resolve(res);
        }).catch(error => {
            return Promise.reject(error);
        });
    }
    getMarketValue(fundIds, investmentTerm, url) {
        //return Promise.resolve(JSON.parse(localStorage.getItem("mockData2")));
        let compareHeaders = {
            intSvcName: "sis/amtc",
            service: "fundComparisonAPI",
            investmentTerm: investmentTerm,
            transactionId:sessionStorage.getItem("s_key")
        }
        if (fundIds.length === 2) {
            compareHeaders.fundId_1 = fundIds[0];
            compareHeaders.fundId_2 = fundIds[1];
        } else if (fundIds.length === 3) {
            compareHeaders.fundId_1 = fundIds[0];
            compareHeaders.fundId_2 = fundIds[1];
            compareHeaders.fundId_3 = fundIds[2];
        }
        return window.App.Api.GET(url, {
            headers: compareHeaders,
            cancelGetter: canceller => (this.apiRequestCanceller = canceller)
        }).then(res => {
            return Promise.resolve(res);
        }).catch(error => {
            console.log("Cancelled! 1");
            return Promise.reject(error);
        });
    }
}
export default WidgetFundComparisonHelpers;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-amtc-fund-comparison/scripts/app-fund-comparison.js